var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddShip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5650",
    "data-name": "Group 5650",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3450",
    "data-name": "Rectangle 3450",
    width: 16,
    height: 16,
    transform: "translate(0 0)",
    fill: "#039",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M1.454,16H0V14.546H1.454a5.053,5.053,0,0,0,2.909-.968,5.053,5.053,0,0,0,2.91.933h.019c-.013.158-.02.323-.02.489a6.048,6.048,0,0,0,.08.982H7.273a6.329,6.329,0,0,1-2.91-.709A6.388,6.388,0,0,1,1.454,16Zm5.818-2.909a4.041,4.041,0,0,1-2.909-1.454,4.046,4.046,0,0,1-2.909,1.454H1.41L.036,8.226a.787.787,0,0,1,.043-.56A.752.752,0,0,1,.516,7.3L1.454,7V3.637A1.456,1.456,0,0,1,2.909,2.182H5.09V0H9.454V2.182h2.182A1.456,1.456,0,0,1,13.09,3.637V7l.938.305a.747.747,0,0,1,.436.365.786.786,0,0,1,.044.56l-.243.856A6.067,6.067,0,0,0,13.272,9a6,6,0,0,0-5.685,4.076C7.48,13.086,7.374,13.091,7.272,13.091Zm0-8h0l4.364,1.425V3.637H2.909v2.88L7.272,5.091Z",
    transform: "translate(0.728)",
    fill: "#039"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-alarm-add",
    "data-name": "Icon material-alarm-add",
    d: "M15.293,13.5H13.976v1.976H12v1.317h1.976v1.976h1.317V16.793h1.976V15.476H15.293Z",
    transform: "translate(-1.269 -2.79)",
    fill: "#039"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddShip);
export default __webpack_public_path__ + "static/media/addShip.a8272904ad46ac9e3959990487fb4f8b.svg";
export { ForwardRef as ReactComponent };